import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import config from '../config.json';

const userManager = new UserManager({
  authority: config.authority,
  client_id: config.client_id,
  client_secret: config.client_secret,
  redirect_uri: `${window.location.protocol}//${window.location.host}/callback`,
  post_logout_redirect_uri: `${window.location.protocol}//${window.location.host}`,
  response_type: 'code',
  scope: 'openid profile email groups',
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  token_endpoint_auth_method: 'client_secret_post',
});

export default userManager;
